'use client';

import Image from 'next/image';
import { cn } from '@/lib/utils';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
  priority?: boolean;
}

/**
 * Logo NossoERP com suporte a dark mode.
 * Exibe a versao clara no tema light e a versao escura no tema dark.
 */
export function Logo({ width = 140, height = 32, className, priority }: LogoProps) {
  return (
    <>
      <Image
        src="/img/NossoERP.png"
        alt="NossoERP"
        width={width}
        height={height}
        className={cn('logo-glow dark:hidden', className)}
        priority={priority}
      />
      <Image
        src="/img/NossoERP-dark.png"
        alt="NossoERP"
        width={width}
        height={height}
        className={cn('logo-glow hidden dark:block', className)}
        priority={priority}
      />
    </>
  );
}
